import { useState } from 'react';
import { Button } from '@chakra-ui/react';

import { DateInputWithConfirm, Modal, isValidDate } from 'shared-components';

import { IDate } from '../../../../types';
import { useTranslation } from "react-i18next";

export interface IProps {
  label: string;
  value?: IDate;
  onUpdate: (date: IDate) => void;
  onClose: () => void;
}

const EditDateModal = (props: IProps) => {
    const { t } = useTranslation('dialogs');
  const { label, value } = props;

  const [date, setDate] = useState(() => value || { DD: null, MM: null, YYYY: null });
  const [dateError, setDateError] = useState('');

  const onFocusDate = () => {
    if (dateError !== '') {
      setDateError('');
    }
  };

  const onBlurDate = () => {
    if (!isValidDate(date)) {
      setDateError('Please ensure the date is correct');
    }
  };

  const submit = () => {
    if (!isValidDate(date)) {
      return;
    }
    props.onUpdate(date);
    props.onClose();
  };

  return (
    <Modal
      id="edit-date"
      show={true}
      title={t('dialogs:editValue')}
      onClose={props.onClose}
      footer={
        <Button id="submit-log-button" onClick={submit} isDisabled={!isValidDate(date)} variant={'solid'} size={'lg'}>
          Change
        </Button>
      }
    >
      <DateInputWithConfirm
        value={date}
        label={label}
        errorText={dateError}
        onChangeDD={(evt: any) => {
          const { value } = evt.currentTarget;
          setDate(date => ({
            ...date,
            DD: value,
          }));
        }}
        onChangeMM={(evt: any) => {
          const { value } = evt.currentTarget;
          setDate(date => ({
            ...date,
            MM: value,
          }));
        }}
        onChangeYY={(evt: any) => {
          const { value } = evt.currentTarget;
          setDate(date => ({
            ...date,
            YYYY: value,
          }));
        }}
        onBlur={onBlurDate}
        onFocus={onFocusDate}
      />
    </Modal>
  );
};

export default EditDateModal;
